import React, { useEffect, useState } from "react";

export default function ReadingProgress() {
  const [progress, setProgress] = useState(0);

  useEffect(() => {
    const container = document.getElementById("scroll-container");
    if (!container) return;

    const onScroll = () => {
      const max = container.scrollHeight - container.clientHeight;
      setProgress(max > 0 ? container.scrollTop / max : 0);
    };

    onScroll();
    container.addEventListener("scroll", onScroll, { passive: true });
    return () => container.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <div
      className="fixed top-0 left-0 h-[2px] bg-Sapphire z-[60] transition-[width] duration-100 ease-out"
      style={{ width: `${progress * 100}%` }}
    ></div>
  );
}
